import Grid from "@mui/material/Grid";
import { DataGridListStyle, BtnGroupWAStyle, HtmlTooltip } from "../../Theme";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { YSButton } from "../../uikit/YSButton";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadingFavoritePharmacyDataList } from "../../Redux/Slice/FavoritePharmacyDataListSlice";
import { v4 as uuid } from "uuid";
import { DialogPopup } from "../DialogPopup";
import ConfirmPopup from "../ConfirmPopup";
import {
  PharmacyPopulate,
  RemoveFavoritePharmacyDataListById,
} from "../../Apis/AuthApiServices";
import YSSnackBar from "../../uikit/YSSnackBar";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import NoRecords from "../NoRecords";
import ErrorOverlay from "../ErrorOverlay";
import { loadingPharmacyDropDown } from "../../Redux/Slice/PharmacyDropDownSlice";
import { Typography } from "@mui/material";
import ErxWarning from "../../images/icons/ErxWarning.svg";
import ErxSuccess from "../../images/icons/ErxSuccess.svg";
import ErxError from "../../images/icons/ErxError.svg";
import { IconButton } from "@mui/material";

export default function FavoritePharmacyDataList(props: any) {
  const {
    handleHidePopupClick,
    fetchApi,
    setPharmacyPopulateId,
    pharmacyCodeOptionClass,
    setPharmacyCodeOptionClass,
    handlepharmacyCodeRefClick,
    formData,
  } = props;
  const dispatch = useDispatch();
  const FavoritePharmacyDataListState = useSelector((state: any) => {
    return { ...state.FavoritePharmacyDataListSlice };
  }); //redux data
  const [page, setPage] = useState(0);
  const [selectionData, setSelectionData] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [deleteFavPharmacyPopup, setDeleteFavPharmacyPopup] = useState(false);
  const [deleteStateData, setDeleteStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const [rowCountState, setRowCountState] = useState(
    FavoritePharmacyDataListState?.Pagination?.totalItems || 0
  );
  const handleShowDeleteFavPharmacyPopupClick = () => {
    setDeleteFavPharmacyPopup(true);
  };
  const handleHideDeleteFavPharmacyPopupClick = () => {
    setDeleteFavPharmacyPopup(false);
  };
  const getPharmacyPopulate = async (PharmacyCode: any) => {
    try {
      const bodyData = {
        ...formData,
        patientId: sessionStorage.getItem("patientId"),
        pharmacyCode: PharmacyCode,
        ssEnableFlag: pharmacyCodeOptionClass,
      };
      const result = await PharmacyPopulate(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setPharmacyPopulateId(result?.data?.response);
        handleHidePopupClick();
        dispatch(loadingPharmacyDropDown());
      } else {
        setPharmacyPopulateId([formData]);
      }
    } catch (error) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const deleteRowData = async () => {
    try {
      const params = new URLSearchParams();
      params.append("userFavoritePharmacyId", selectionData);
      const result = await RemoveFavoritePharmacyDataListById(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        getFavoritePharmacyDataList(page);
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err: any) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const getFavoritePharmacyDataList = (nextPage: number) => {
    let pageNumber = {
      pageNumber: nextPage,
    };
    dispatch(loadingFavoritePharmacyDataList(pageNumber));
  };

  const pharmacyColumns: GridColDef[] = [
    {
      field: "pharmacyName",
      headerName: "Pharmacy Name / Address",
      width: 200,
      cellClassName: "w50",
      headerClassName: "w50",
      renderCell: ({ row }) => (
        <Typography
          onClick={() => {
            getPharmacyPopulate(row?.pharmacyId);
            handlepharmacyCodeRefClick();
            row?.ssEnableFlag
              ? setPharmacyCodeOptionClass("")
              : setPharmacyCodeOptionClass("yellow");
          }}
          color={"primary"}
          component="div"
        >
          <Grid
            container
            display={"flex"}
            justifyContent={"left"}
            alignItems={"center"}
            gap={1}
          >
            <Grid item>
              <Typography variant="body2">{row?.pharmacyName} </Typography>
            </Grid>
            {row?.ssEnableFlag === false ? (
              <Grid item>
                <img src={ErxError} alt="erx-error" height={24} />
              </Grid>
            ) : row?.epcsEnabled ? (
              <Grid item>
                <img src={ErxSuccess} alt="erx-success" height={24} />
              </Grid>
            ) : (
              <Grid item>
                <img src={ErxWarning} alt="erx-warning" height={24} />
              </Grid>
            )}
          </Grid>
          <Typography color="black" variant="caption">
            <LocationOnIcon style={{ height: 12, width: 12 }} />
            {row?.address}
          </Typography>
        </Typography>
      ),
    },
    {
      field: "city",
      headerName: "City",
      width: 70,
      cellClassName: "w13",
      headerClassName: "w13",
      renderCell: ({ row }) => (
        <Typography style={{ wordBreak: "break-word" }} variant={"body2"}>
          {row?.city}
        </Typography>
      ),
    },
    {
      field: "state",
      headerName: "State",
      width: 70,
      cellClassName: "w8",
      headerClassName: "w8",
    },
    {
      field: "zip",
      headerName: "Zip",
      width: 70,
      cellClassName: "w8",
      headerClassName: "w8",
    },
    {
      field: "phoneNumber",
      headerName: "Telephone",
      width: 100,
      cellClassName: "w12",
      headerClassName: "w12",
    },
    {
      field: "specialityType",
      headerName: "Type",
      width: 100,
      cellClassName: "w8",
      headerClassName: "w8",
    },
  ];

  useEffect(() => {
    getFavoritePharmacyDataList(page);
  }, [page]);

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      FavoritePharmacyDataListState?.Pagination?.totalItems !== undefined
        ? FavoritePharmacyDataListState?.Pagination?.totalItems
        : prevRowCountState
    );
  }, [FavoritePharmacyDataListState?.Pagination?.totalItems, setRowCountState]);

  return (
    <Grid
      container
      item
      xs={12}
      spacing={0}
      alignItems="center"
      justifyContent="center"
    >
      {" "}
      <Grid item xs={12}>
        <Typography textAlign={"right"} variant="caption" component="div">
          <Typography fontWeight={"bold"} variant="body2">
            *TYPE:{" "}
            <Typography fontWeight={600} variant="caption">
              MO - Mail Order, RT - Retail, IH - In House, FO - Fax Only, LTC -
              Long Term Care,{" "}
              <>
                <HtmlTooltip
                  placement="bottom"
                  arrow
                  title={
                    "This pharmacy supports electronic prescription transmission."
                  }
                >
                  <IconButton className="">
                    <img src={ErxSuccess} alt="erx-success" height={24} />
                  </IconButton>
                </HtmlTooltip>
                ,
              </>
              <>
                <HtmlTooltip
                  placement="bottom"
                  arrow
                  title={
                    "Electronic transmission of prescriptions containing Controlled drugs is not supported by this pharmacy."
                  }
                >
                  <IconButton className="">
                    <img src={ErxWarning} alt="erx-warning" height={24} />
                  </IconButton>
                </HtmlTooltip>
                ,
              </>
              <>
                <HtmlTooltip
                  placement="bottom"
                  arrow
                  title={
                    "Electronic transmission of prescriptions is disabled for this pharmacy."
                  }
                >
                  <IconButton className="">
                    <img src={ErxError} alt="erx-error" height={24} />
                  </IconButton>
                </HtmlTooltip>
              </>
            </Typography>
          </Typography>{" "}
        </Typography>
        <DataGridListStyle>
          <DataGrid
            rows={FavoritePharmacyDataListState?.Items ?? []}
            headerHeight={36}
            sortingOrder={["desc", "asc"]}
            columns={pharmacyColumns}
            autoHeight
            rowHeight={40}
            getRowHeight={() => "auto"}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[10]}
            disableSelectionOnClick
            paginationMode="server"
            checkboxSelection
            components={{
              NoRowsOverlay: NoRecords,
              NoResultsOverlay: NoRecords,
              ErrorOverlay: ErrorOverlay,
            }}
            error={FavoritePharmacyDataListState?.error || undefined}
            getRowId={(row) => row?.userFavoritePharmacyId ?? uuid()}
            loading={FavoritePharmacyDataListState?.isLoading}
            page={page}
            onPageChange={(newPage) => {
              setPage(newPage);
            }}
            rowCount={rowCountState}
            onSelectionModelChange={(ids: any) => {
              setSelectionData(ids);
            }}
            getRowClassName={(params) => {
              if (!params.row.ssEnableFlag) {
                return "yellow";
              }
              return "";
            }}
          />
        </DataGridListStyle>
      </Grid>
      <Grid item xs={12}>
        <BtnGroupWAStyle>
          <YSButton
            onClick={handleShowDeleteFavPharmacyPopupClick}
            className="secondary"
            children={"Delete"}
            size={"large"}
            type="button"
            variant="outlined"
          />
        </BtnGroupWAStyle>
        <DialogPopup
          windowsize={"sm"}
          show={deleteFavPharmacyPopup}
          handleShowPopupClick={handleShowDeleteFavPharmacyPopupClick}
          handleHidePopupClick={handleHideDeleteFavPharmacyPopupClick}
          close={true}
        >
          <ConfirmPopup
            deleteRowData={deleteRowData}
            handleHideDeletePopupClick={handleHideDeleteFavPharmacyPopupClick}
          />
        </DialogPopup>
        <YSSnackBar
          message={deleteStateData.message}
          variant={deleteStateData.variant}
          open={deleteStateData.open}
          handleClose={() => {
            setDeleteStateData((prevState: any) => {
              return { ...prevState, open: false };
            });
          }}
        />
      </Grid>
    </Grid>
  );
}
